const template = `
<div>
  <div class="own-profit-hgroup">
  <div class="own-profit-vgroup">
    <div class="own-profit-hgroup">
      <input type="text" class="own-profit-value"/>
      <span>%</span>
    </div>
    <span class="own-profit-spacer-full">&nbsp;</span>
  </div>
  <div class="own-profit-vgroup">
    <span class="own-profit-other">Övriga hästar: %percentage%</span>
    <span class="own-profit-remaining">Återstår: %remaining%</span>
  </div>
  </div>
</div>
`;

export default template;
